module.exports = __webpack_public_path__ + "centric-card-bottom-right@2x.aWBH_v37.png";